/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Semantic_SearchInputs */

const en_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic search`)
};

const ar_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث الدلالي`)
};

const bn_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেম্যান্টিক সার্চ`)
};

const de_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantische Suche`)
};

const es_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda semántica`)
};

const fr_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche sémantique`)
};

const pt_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa semântica`)
};

const zh_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语义搜索`)
};

const tr_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlamsal arama`)
};

const ru_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семантический поиск`)
};

const pl_svchip_semantic_search = /** @type {(inputs: Svchip_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie semantyczne`)
};

/**
* | output |
* | --- |
* | "Semantic search" |
*
* @param {Svchip_Semantic_SearchInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_semantic_search = /** @type {((inputs?: Svchip_Semantic_SearchInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Semantic_SearchInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_semantic_search(inputs)
	if (locale === "bn") return bn_svchip_semantic_search(inputs)
	if (locale === "de") return de_svchip_semantic_search(inputs)
	if (locale === "es") return es_svchip_semantic_search(inputs)
	if (locale === "fr") return fr_svchip_semantic_search(inputs)
	if (locale === "pt") return pt_svchip_semantic_search(inputs)
	if (locale === "zh") return zh_svchip_semantic_search(inputs)
	if (locale === "tr") return tr_svchip_semantic_search(inputs)
	if (locale === "ru") return ru_svchip_semantic_search(inputs)
	if (locale === "pl") return pl_svchip_semantic_search(inputs)
	return en_svchip_semantic_search(inputs)
});